import { Directive, inject } from '@angular/core';
import { ImmomioIconName } from '../../models';
import { WhitelabelImage, WhitelabelImageType } from '../../models';
import { StorageService } from '../../infrastructure';

@Directive()
export abstract class OnboardingBaseComponent {
  public readonly whitelabelImage = WhitelabelImage;
  public readonly whitelabelImageType = WhitelabelImageType;
  public readonly immomioIconName = ImmomioIconName;

  private readonly storageService = inject(StorageService);

  public setOnboardingCompleted(): void {
    this.storageService.setItem('onboardingCompleted', 'true');
  }
}
